import React from 'react'

import Icon from '@scoir/components-core/dist/components/Icon'
import scheduleIcon from 'icons/schedule.svg'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'

export class MessageNotification extends React.Component {
  renderAgoText(date) {
    return moment(date).fromNow()
  }

  render() {
    return (
      <div
        className="actionable"
        onClick={() => this.props.onClick()}
      >
        <span className="subject">{this.props.item.Subject}</span>
        {this.props.item.Text && <div className="body">{this.props.item.Text}</div>}
        <p className="time">
          <Icon
            def={scheduleIcon}
            size="xs"
            beforeText
          />
          {this.renderAgoText(this.props.item.CreatedDate)}
        </p>
      </div>
    )
  }
}

MessageNotification.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default MessageNotification
